import { AttachmentButton } from "@/actuals/AccountingBill";
import { Grid, IconButton } from "@mui/material";
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import DehazeRoundedIcon from '@mui/icons-material/DehazeRounded';
import RefuteBillPopup from "./RefuteBillPopup";
import { ACCOUNTING_BILL_STATUS_ALLOCATED } from "@/actuals/constants";

export default function AccountingBillActions({bill, onExpand}) {
    const canRefute = bill.status == ACCOUNTING_BILL_STATUS_ALLOCATED
    return (<Grid container width={"fit-content"} wrap="nowrap" alignItems="center">
        <Grid item>
            {bill.attachments.length > 0 &&
                <AttachmentButton
                    openMenu={handleMenuOpen}
                    attachment={bill.attachments.length == 1 && bill.attachments[0]}
                />
            }
        </Grid>
        <Grid item>
            {bill.file_url &&
                <IconButton href={bill.file_url}>
                    <InsertDriveFileOutlinedIcon />
                </IconButton>
            }
        </Grid>
        <Grid item>
            {onExpand &&
            <IconButton onClick={onExpand}>
                <DehazeRoundedIcon />
            </IconButton>}
        </Grid>
        <Grid item>
            {((bill.bill_lines.length > 0) && canRefute) &&
                <RefuteBillPopup bill={bill}/>
            }
        </Grid>
    </Grid>)
}